module.exports = __webpack_public_path__ + "static/media/CSBigLogo.98795acd.webp";